import { PARTNER } from '@/common/constants/userTypes';

// Остаток тестов пользователя для шапки и таблиц. У партнёра это новое поле stock_balance
// (то же число, что в его кабинете), у остальных ролей пока старый счётчик licenses_available.
export default function userTestsBalance(user) {
  if (!user) return '';
  if (user.user_type === PARTNER && user.stock_balance !== undefined && user.stock_balance !== null) {
    return user.stock_balance;
  }
  return user.licenses_available;
}
